import { reloadPage } from './reloadPage';

export const finishPaymentSuccessNavigation = (): void => {
  if (typeof window === 'undefined') return;

  if (window.location.pathname.includes('/packages/payment')) {
    window.location.href = window.location.href.replace(
      '/packages/payment',
      '/packages'
    );
    return;
  }

  reloadPage();
};
